/***** SCRIPTS POUR GÉRER LES OFFRES D'EMPLOI *****/

    $('document').ready(setupJobOffers);

    function setupJobOffers() {
        initJobOffersListPage();
        backToFilters();
    }

    // Page des offres d'emplois
    function initJobOffersListPage() {
        // On récupère la liste des familles d'emplois
        var data = {
            'action': 'load_family_offers_ajax',
            'security': site.security
        };
        $.post(site.ajaxurl, data, function(response) {
            if(response.data) {
                var optionsFamilies = [];
                if(response.data.familyoffers) {
                    var familiesOffers = response.data.familyoffers;
                    var options = [];
                    var selectedValueFamily = '';
                    for(var i=0;i<familiesOffers.length;i++)  {
                        var optionsChildrens = [];
                        for(var j=0;j<familiesOffers[i]['childrens'].length;j++)  {
                            optionsChildrens.push({ label: familiesOffers[i]['childrens'][j].label + ' (' + familiesOffers[i]['childrens'][j].count + ')', value: familiesOffers[i]['childrens'][j].ID })
                        }
                        if(optionsChildrens.length !== 0) {
                            options.push({ label: familiesOffers[i].label + ' (' + familiesOffers[i].count + ')', value: familiesOffers[i].ID, options: optionsChildrens })
                        }else {
                            options.push({ label: familiesOffers[i].label + ' (' + familiesOffers[i].count + ')', value: familiesOffers[i].ID })
                        }
                    }
                    var url = document.location.href;
                    var qs = url.substring(url.indexOf('?') + 1).split('&');
                    for(var i = 0, result = {}; i < qs.length; i++){
                        qs[i] = qs[i].split('=');
                        result[qs[i][0]] = decodeURIComponent(qs[i][1]);
                    }
                    if(result.famille && result.famille.split(',').length !== 0) {
                        selectedValueFamily = result.famille.split(',');
                    }
                    VirtualSelect.init({
                        ele: '#familyOffers',
                        options: options,
                        multiple: true,
                        search: false,
                        name: 'famille',
                        disableSelectAll: true,
                        showDropboxAsPopup: false,
                        useGroupValue: true,
                        selectedValue: selectedValueFamily,
                        position: 'bottom',
                        optionHeight: '50px',
                        placeholder: 'Famille / Emploi',
                        selectAllText: 'Tout sélectionner',
                        optionsSelectedText: 'familles/emplois sélectionné(e)s',
                        optionSelectedText: 'famille/emploi sélectionné(e)',
                        allOptionsSelectedText: 'Toutes les familles et emplois',
                        noOptionsText: 'Aucun résultat n\'est disponible',
                        noSearchResultsText: 'Aucun résultat disponible pour votre recherche.',
                        clearButtonText: 'Réinitialiser'
                    });
                }
            }
        });

        // On récupère la localisation
        var data = {
            'action': 'load_locations_offers_ajax',
            'security': site.security
        };
        $.post(site.ajaxurl, data, function(response) {
            if(response.data) {
                var optionsLocations = [];
                if(response.data.locations) {
                    var localizations = response.data.locations;
                    var options = [];
                    var selectedValueLocation = '';
                    for(var i=0;i<localizations.length;i++) {
                        var optionsChildrens = [];
                        for(var j=0;j<localizations[i]['childrens'].length;j++)  {
                            optionsChildrens.push({ label: localizations[i]['childrens'][j].label + ' (' + localizations[i]['childrens'][j].count + ')', value: localizations[i]['childrens'][j].ID })
                        }
                        if(localizations[i].label !== 'Espagne' && localizations[i].label !== 'Italie' && localizations[i].label !== 'Allemagne' && localizations[i].label !== 'Portugal') {
                            if(optionsChildrens.length !== 0) {
                                options.push({ label: localizations[i].label + ' (' + localizations[i].count + ')', value: localizations[i].ID, options: optionsChildrens })
                            }else {
                                options.push({ label: localizations[i].label + ' (' + localizations[i].count + ')', value: localizations[i].ID })
                            }
                        }else {
                            if(optionsChildrens.length !== 0) {
                                options.unshift({ label: localizations[i].label + ' (' + localizations[i].count + ')', value: localizations[i].ID, options: optionsChildrens })
                            }else {
                                options.unshift({ label: localizations[i].label + ' (' + localizations[i].count + ')', value: localizations[i].ID })
                            }
                        }
                    }
                    var url = document.location.href;
                    var qs = url.substring(url.indexOf('?') + 1).split('&');
                    for(var i = 0, result = {}; i < qs.length; i++){
                        qs[i] = qs[i].split('=');
                        result[qs[i][0]] = decodeURIComponent(qs[i][1]);
                    }
                    if(result.lieu && result.lieu.split(',').length !== 0) {
                        selectedValueLocation = result.lieu.split(',');
                    }
                    VirtualSelect.init({
                        ele: '#locationOffers',
                        options: options,
                        multiple: true,
                        search: false,
                        name: 'lieu',
                        disableSelectAll: true,
                        showDropboxAsPopup: false,
                        selectedValue: selectedValueLocation,
                        useGroupValue: true,
                        position: 'bottom',
                        optionHeight: '50px',
                        placeholder: 'Localisation du poste',
                        selectAllText: 'Tout sélectionner',
                        optionsSelectedText: 'localisations sélectionnées',
                        optionSelectedText: 'localisation sélectionnée',
                        allOptionsSelectedText: 'Toutes les localisations',
                        noOptionsText: 'Aucun résultat n\'est disponible',
                        noSearchResultsText: 'Aucun résultat disponible pour votre recherche.',
                        clearButtonText: 'Réinitialiser'
                    });
                }
            }
        });

        if($('#activite').length !== 0) {
            var options = [];
            var selectedValueActivity = '';
            $('#activite option').each(function() {
                if(this.value !== '' && this.value !== ' ') {
                    options.push({ label: this.label, value: this.value })
                }
            });
            var url = document.location.href;
            var qs = url.substring(url.indexOf('?') + 1).split('&');
            for(var i = 0, result = {}; i < qs.length; i++){
                qs[i] = qs[i].split('=');
                result[qs[i][0]] = decodeURIComponent(qs[i][1]);
            }
            if(result.activite && result.activite.split(',').length !== 0) {
                selectedValueActivity = result.activite.split(',');
            }
            VirtualSelect.init({
                ele: '#activitesOffers',
                options: options,
                multiple: true,
                search: false,
                name: 'activite',
                disableSelectAll: true,
                showDropboxAsPopup: false,
                selectAllOnlyVisible: true,
                showSelectedOptionsFirst: true,
                selectedValue: selectedValueActivity,
                position: 'bottom',
                optionHeight: '50px',
                placeholder: 'Activités',
                selectAllText: 'Tout sélectionner',
                optionsSelectedText: 'activités sélectionnées',
                optionSelectedText: 'activité sélectionnée',
                allOptionsSelectedText: 'Toutes les activités',
                noOptionsText: 'Aucun résultat n\'est disponible',
                noSearchResultsText: 'Aucun résultat disponible pour votre recherche.',
                clearButtonText: 'Réinitialiser'
            });
        }

        if($('#type-contrat').length !== 0) {
            var options = [];
            var selectedValueContract = '';
            $('#type-contrat option').each(function() {
                if(this.value !== '' && this.value !== ' ') {
                    options.push({ label: this.label, value: this.value })
                }
            });
            var url = document.location.href;
            var qs = url.substring(url.indexOf('?') + 1).split('&');
            for(var i = 0, result = {}; i < qs.length; i++){
                qs[i] = qs[i].split('=');
                result[qs[i][0]] = decodeURIComponent(qs[i][1]);
            }
            if(result.contrat && result.contrat.split(',').length !== 0) {
                selectedValueContract = result.contrat.split(',');
            }
            VirtualSelect.init({
                ele: '#contractOffers',
                options: options,
                multiple: true,
                search: false,
                name: 'contrat',
                disableSelectAll: true,
                showDropboxAsPopup: false,
                selectAllOnlyVisible: true,
                showSelectedOptionsFirst: true,
                selectedValue: selectedValueContract,
                position: 'bottom',
                optionHeight: '50px',
                placeholder: 'Type de contrat',
                selectAllText: 'Tout sélectionner',
                optionsSelectedText: 'contrats sélectionnées',
                optionSelectedText: 'contrat sélectionnée',
                allOptionsSelectedText: 'Tous les types de contrats',
                noOptionsText: 'Aucun résultat n\'est disponible',
                noSearchResultsText: 'Aucun résultat disponible pour votre recherche.',
                clearButtonText: 'Réinitialiser'
            });
        }

        // Gestion du Virtual Select
        $('.virtualselect ').on('beforeOpen', function() {
            var listHeight = $(this).find('.vscomp-dropbox').innerHeight() + 57;
            $(this).find('.vscomp-dropbox-container').css('max-height', listHeight + 'px');
        });
        $('.virtualselect ').on('beforeClose', function() {
            $(this).find('.vscomp-dropbox-container').removeAttr('style');
        });
        $('.virtualselect  .vscomp-search-clear').on('click', function(e) {
            var listHeight = $(this).parent().parent().parent().innerHeight() + 57;
            $(this).parent().parent().parent().parent().css('max-height', listHeight + 'px');
        });

        $('.jobcard').on('click', getJobofferInfos);
        if($('.joboffers-offer.show').length !== 0 && $(window).width() < 1000) {
            $('html, body').css('overflow', 'hidden');
        }

        // Adapter l'affichage d'une offre ou pas au resize de la fenetre
        $(window).resize(function() {
            if($(window).width() >= 1000) {
                $('html, body').removeAttr('style');
            }else if($('.joboffers-offer.show').length !== 0) {
                $('html, body').css('overflow', 'hidden');
            }
        });

        // Scroller vers l'offre quand on l'ouvre depuis une URL externe
        if($('body').hasClass('single-offre-emploi')) {
            if($(window).width() >= 1000) {
                var offset = $('#offre').offset().top - 100;
                $('html, body').animate({scrollTop: offset}, 1000);
            }
        }

        // Initialisation du bouton de retour des offres d'emplois
        $(".joboffers-offer .btn-back").on('click',function(e) {
            $(".joboffers-offer").removeClass("show");
            $('.joboffers-loader').removeClass('show');
            $('.jobcard.current').removeClass('current');
            $('html, body').removeAttr('style');
        });
    }

    // Charger les offres d'emplois en AJAX
    function getJobofferInfos(e) {
        e.preventDefault();
        var offset = $(".joboffers-offer").offset().top;

        // Chargement loader
        $('.joboffers-loader').addClass('show');
        if($(window).width() < 1000) {
            $('html, body').css('overflow', 'hidden');
        }else {
            $('html, body').animate({scrollTop: offset - 100 }, 'slow');
        }

        if ( $(this).hasClass("current") ) {
            $(".joboffers-offer").addClass("show");
        }else {
            $('.jobcard.current').removeClass('current');
            $(this).addClass("current");
            
            // Chargement
            $(".joboffers-offer").removeClass("show").addClass("load");

            // On charge l'offre d'emploi en AJAX
            var id = $(this).attr('data-id');
            var url = $(this).attr('href');
            var title = $(this).attr('data-title');
            var data = {
                'action': 'load_joboffer_by_ajax',
                'post_id': id,
                'security': site.security
            };
            history.pushState( { url: url, id: id }, "", url);
            document.title = title;
            $.post(site.ajaxurl, data, function(response) {
                if($.trim(response) !== '') {
                    $('#offre').html(response);
                    $(".joboffers-offer").removeClass("load");
                    $(".joboffers-offer").addClass("show");
                    $('.joboffers-loader').removeClass('show');
                }else {
                    console.log('Erreur de chargement offre emploi');
                }
            });
        }
    }

    // Remonter au niveau des filtres sur mobile et tablette
    function backToFilters() {
        var btnScroll = $('#scroll-to-filters');

        // Affiche le bouton au scroll
        $(window).on('scroll',function() {
            if (($(window).width() <= 1000) && ($(window).scrollTop() > 300)) {
                btnScroll.addClass('visible');
            } else {
                btnScroll.removeClass('visible');
            }
        });

        // Action du bouton
        btnScroll.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({scrollTop:300}, '300');
        });

    }

    